import { appNavigateTo } from "../store/actions/navActions";
import AuditLogging from '../services/AuditLogging.Service';
import { geteApplyCookieValue, isFFNCard } from "../shared/SharedUtility";
import { isPartnerChannelCode } from "../shared/PartnerUtility";
import { clearUserData } from "../store/actions/UserAction";
import { clearSSLData } from "../store/actions/SslActions";
import { getGEMID1, getGEMID2 } from "../shared/utility";
export const getScreen = (userDetail) => {
    const { state } = userDetail;
    let screenDetails = { goTo: "", detailsScreen: "" };

    switch (state) {
        case "RT001":
            screenDetails = { goTo: "city", detailsScreen: "personalDetails" };
            break;
        case "RT002":
            screenDetails = { goTo: "city", detailsScreen: "personalDetails" };
            break;
        case "RT003":
            screenDetails = { goTo: "pan", detailsScreen: "personalDetails" };
            break;
        case "RT004":
            screenDetails = { goTo: "pan", detailsScreen: "personalDetails" };
            break;
        case "RT005":
            screenDetails = { goTo: "email", detailsScreen: "personalDetails" };
            break;
        case "RT006":
            screenDetails = { goTo: "professional", detailsScreen: "professionalDetails" };
            break;
        case "RT007":
            screenDetails = { goTo: "professional", detailsScreen: "professionalDetails" };
            break;
        case "RT008":
            screenDetails = { goTo: "officeaddress", detailsScreen: "professionalDetails" };
            break;
        // case "RT012": leadAge less than 30 days, channelcode RINB or YNCP, no application number
        // case "RT014": leadAge 30+ days, channelcode RINB or YNCP, no application number
        case "TR001":
            screenDetails = { goTo: "resiaddress", detailsScreen: "kycDetails" };
            break;
        case "TR002":
            screenDetails = { goTo: "digiConsent", detailsScreen: "kycDetails" };
            break;
        case "TR003":
            screenDetails = { goTo: "resiaddress", detailsScreen: "kycDetails" }; // update goTo
            break;
        case 'TR004':
            screenDetails = { goTo: 'kycDetails', detailsScreen: 'kycDetails' }; //need to update. should be gender
            break;
        case 'TR005':
            screenDetails = { goTo: 'takePhoto', detailsScreen: 'kycDetails' };
            break;
        case 'TR006':
            screenDetails = { goTo: 'takePhoto', detailsScreen: 'kycDetails' };
            break;
        case 'TR007':
            screenDetails = { goTo: 'penydrop', detailsScreen: 'kycDetails' };
            break;
        case 'TR008':
            screenDetails = { goTo: 'applicationConscent', detailsScreen: "MitMidc" };
            break;
        case 'TR009':
            screenDetails = { goTo: 'completeApplication', detailsScreen: "kycDetails" };
            break;
        case 'TR010':
            screenDetails = { goTo: 'credit', detailsScreen: "kycDetails" };
            break;
        case "TR011":
            screenDetails = { goTo: "resiaddress", detailsScreen: "kycDetails" }; // update goTo
            break;
        case "TR013":
            screenDetails = { goTo: "resiaddress", detailsScreen: "kycDetails" }; // update goTo
            break;
        case "TR014":
            screenDetails = { goTo: "kycDetails", detailsScreen: "kycDetails" }; // update goTo
            break;
        case "TR015":
            screenDetails = { goTo: "uploadPanView", detailsScreen: "MITCMID" }; // update goTo
            break;
        case 'TR017':
            screenDetails = { goTo: 'CADScreen', detailsScreen: 'kycDetails' };
            break;
        // case "TR018":
        //     screenDetails = { goTo: "VkycMitc", detailsScreen: "kycDetails" };
        //     break;
        case "ERR14":
            screenDetails = { goTo: "VkycStatus", detailsScreen: "kycDetails" };
            break;
            case "ERR15":
                screenDetails = { goTo: "wip", detailsScreen: "kycDetails" };
                break;
        case "ERR16":
            screenDetails = { goTo: "wip", detailsScreen: "kycDetails" };
            break;
        case "TR023":
                    screenDetails = { goTo: "VkycRedirectionStatus", detailsScreen: "kycDetails" };
            break;
        case "TR024":
                screenDetails = { goTo: "resiaddress", detailsScreen: "kycDetails" }; //goTo addres update DIGIMOD
            break;
            case "TR025":
                screenDetails = { goTo: "telcoValidateOTP", detailsScreen: "kycDetails" }; //goTo Telco OTP screen
            break;  
            case "TR027":
               screenDetails = {goTo: "incomeSurrogate", detailsScreen: "kycDetails" }; //goTo addres update DIGIMOD
                break;
             case "TR028":
                screenDetails = {goTo: "accountAggregatorStatus", detailsScreen: "kycDetails" }; //goTo addres update DIGIMOD
                break;
            case "TR029":
                screenDetails = {goTo: "conditionalMITC", detailsScreen: "kycDetails" }; //goTo addres update DIGIMOD
                break;
            case "TR030":
                screenDetails = {goTo: "GstOptionScreen", detailsScreen: "MitMidc" }; //goTo addres update DIGIMOD
                break;    
            // case "TR029":
            //     screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            //     break;
        case "TR018":
        case "TR020":
        case "TR021":
            screenDetails = { goTo: "vkycOptionScreen", detailsScreen: "kycDetails" };
            break;
        case "TR022":
            screenDetails = { goTo: "vkycOptionScreen", detailsScreen: "kycDetails" };
            break;
        case "ERR01":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR02":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR03":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR04":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR05":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR06":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR07":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR08":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR09":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR10":
            if(isPartnerChannelCode(userDetail.channelCode))
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            else
            screenDetails = { goTo: "sd2DataCapture", detailsScreen: "MitMidc" }; // update goTo
            break;    
        case "ERR12":
            screenDetails = { goTo: "wip", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "ERR13":
            screenDetails = { goTo: "sd2VkycContinue", detailsScreen: "kycDetails" }; // update goTo
            break;
        case "E001":
            screenDetails = { goTo: "customerEnhancement", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "E002":
            screenDetails = { goTo: "customerEnhancement", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "E004":
            screenDetails = { goTo: "customerEnhancement", detailsScreen: "MitMidc" }; // update goTo
            break;
        case "RT000":
            screenDetails = { goTo: "EapplyContinue", detailsScreen: "MitMidc" }; // update goTo
            break;
        default:
            break;
    }
    return screenDetails;
};

export const getSSLData = (data) => {
    return {
        beaureDemoGender: data.gender,
        ckycGender: "",
        ckycResiAddr: [],
        companyName: data.companyName,
        designation: data.designation,
        digiGender: "",
        digiResiAddress: [],
        digilockerUrl: "",
        dob: data.dob?.replace(/\//g, ''),
        emailId: data.emailId,
        motherName: data.motherName,
        occupation: data.occupation,
        officeAddr: data.officeAddr,
        panNumber: data.panNumber,
        resiAddr: [],
        city: data.resiCity,
        shortCode: data.shortCode,
        state: data.state,
        nameMatchFlag:data.nameMatchFlag,
        dobMatchFlag:data.dobMatchFlag,
        nameOnCard:data.nameOnCard,
        // signedValue: "jaqwheuSQcYqGKE4i0iFw/Wqm5qeg8QMdaYqYeZolmZLAP2a8ZcQTAOvl4q87bUsQYJeFdjG9X/5+PVSOl/PDm8YKA5KmvauHVBadtqXhukXOmBEZkFGFATt0COnbBcpeKIXnzx9kt8P2abXuwdXEt1I6c5K+3tjMlHXD0eXt9I=",
        // submitAction: ,
    }
}

export const getUserDetails = (data) => {
    const { applicantDetails, employmentDetails, officeAddress, contactDetails, state, personalDetails, pennyDropDetails } = data;
    return {
        cardType: data.cardType,
productType:data.productType,        
channelCode: data.channelCode,
        companyName: employmentDetails?.companyName ? employmentDetails.companyName : "",
        companyAlias: employmentDetails?.companyAlias ? employmentDetails?.companyAlias : "",
        companyCategory: employmentDetails?.companyCategory ? employmentDetails?.companyCategory : "",
        designation: employmentDetails?.designation,
        digiConsent: "",
        dob: applicantDetails?.dateOfBirth,
        emailId: applicantDetails?.personalEmailId,
        firstName: applicantDetails?.firstName ? applicantDetails?.firstName : data?.firstName,
        gender: "",
        lastName: applicantDetails?.lastName,
        middleName: applicantDetails?.middleName || "",
        mobileNo: `${applicantDetails?.mobileNumber}`,
        motherName: applicantDetails?.mothersName,
        occupation: employmentDetails?.occupationType,
        officeAddr: {
            addrLine1: officeAddress?.offAddressLine1,
            addrLine2: officeAddress?.offAddressLine2,
            addrLine3: officeAddress?.offAddressLine3,
            pinCode: officeAddress?.offPinCode,
            city: officeAddress?.offCity,
            state: officeAddress?.offState
        },
        panNumber: applicantDetails?.pan,
        resiAddr: [{
            addressType: "", // value will be CKYC/AADHAR/DL/DEMOG/MANUAL as per Pawan
            city: contactDetails?.resiCity,
            houseNo: "",
            landmark: "",
            locality: "",
            pin: contactDetails?.resiPin,
            resiAddressLine2: contactDetails?.resiAddress2,
            state: contactDetails?.resiState,
        }],
        resiCity: contactDetails?.resiCity,
        shortCode: data.shortCode ? data.shortCode : localStorage.getItem("shortCode") ? localStorage.getItem("shortCode") : "",
        submitAction: "",
        state,
        //gemid1: eapplyApplicationDetail?.geMid1 ? eapplyApplicationDetail.geMid1 : "",
        // gemid2: eapplyApplicationDetail?.geMid2 ? eapplyApplicationDetail.geMid2 : "",
        ffnNo: personalDetails?.ffnNo ? personalDetails?.ffnNo : "",
        finalCreditLimit: data?.finalCreditLimit,
        accountDetails: {
            accountNum: pennyDropDetails?.accountNumber ? pennyDropDetails.accountNumber : "",
            ifscCode: pennyDropDetails?.ifscCode ? pennyDropDetails.ifscCode : "",
            bank: pennyDropDetails?.bankName ? pennyDropDetails.bankName : "",
        },
        photoMatchStatus: data?.photoMatchStatus === "PASS" ? true : false,
        pennyDropStatus: isPartnerChannelCode(data?.channelCode) ? null : data?.pennyDropStatus,
        hsToken: data?.hsTokenTrack ? data.hsTokenTrack : data?.hsToken ? data.hsToken : "",
        leadAge: data?.leadAge,
        consentFlag: data?.consentFlag,
        leadSource: data?.leadSource,    
        leadRefNo: data?.leadRefNo,
        gemIdFlag: data?.gemIdFlag,
        selectedSurrogate:data?.selectedSurrogate
    }
}

export const TrackRetNavigate = (userDetail, dispatch, updateState, revisit) => {
    const screenDetails = getScreen(userDetail);
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    const debitRedirect = searchParams.get('debit');
    const eApplyCookie = geteApplyCookieValue();
    const partnerJourney = searchParams.get('partner');
    const hypervergeStatus = searchParams.get('status')?.toUpperCase();
    const finarkeinStatus = searchParams.get('consentStatus')?.toUpperCase();
    const perfiosRedirectSts = searchParams.get('status')?.toUpperCase();
    if (debitRedirect) {
        updateState("landingPageLoad", "debit");
        dispatch(appNavigateTo({ goTo: 'debit', }, "APP_NAVIGATE_TO"));
        AuditLogging.sendLog('321', "", "1", "Redirect to debit page after successful track response.");
    }
    else if (partnerJourney) {
        updateState("partnerRedirect", "digiConsent");
        dispatch(appNavigateTo({ goTo: screenDetails.goTo, }, "APP_NAVIGATE_TO"));
    }
    else if(hypervergeStatus && hypervergeStatus !== "APPROVED"){
        updateState("hypervergeRedirect", "vkycOptionScreen");
        dispatch(appNavigateTo({ goTo: screenDetails.goTo, }, "APP_NAVIGATE_TO"));
    }
    else if(finarkeinStatus) {
        updateState("finarkeinRedirect", "AccountAggregratorStatus");
        dispatch(appNavigateTo({ goTo: screenDetails.goTo, }, "APP_NAVIGATE_TO"));
    }else if(perfiosRedirectSts) {
        updateState("prfisToSprintReditSucc", "accountAggregatorStatus");
        dispatch(appNavigateTo({ goTo: screenDetails.goTo, }, "APP_NAVIGATE_TO"));
    }
    else if ((userDetail && userDetail.state)) {
        let goto;
        if ((eApplyCookie && eApplyCookie?.hsToken)) {
            goto = "EapplyContinue";
        }
        else if (userDetail?.state === "TR008" ||
            userDetail?.state === "TR009" ||
            userDetail?.state === "TR014" ||
            userDetail?.state === "TR015" ||
            userDetail?.state === "ERR01" ||
            userDetail?.state === "ERR02" ||
            userDetail?.state === "ERR03" ||
            userDetail?.state === "ERR04" ||
            userDetail?.state === "ERR05" ||
            userDetail?.state === "ERR06" ||
            userDetail?.state === "ERR07" ||
            userDetail?.state === "ERR08" ||
            userDetail?.state === "ERR09" ||
            userDetail?.state === "ERR10" ||
            userDetail?.state === "ERR12" ||
            userDetail?.state === "ERR13" ||
            userDetail?.state === "ERR14" ||
            userDetail?.state === "ERR15" ||
            userDetail?.state === "ERR16" ||
            userDetail?.state === "RT000" ||
            userDetail?.state === "E001" ||
            userDetail?.state === "E002" ||
            userDetail?.state === "E004" ) {
            goto = screenDetails.goTo;
        } else if (userDetail.state === "RT014") {
            //(variable leadAge >30)when lead has no aplication number and lead is 30 day old & user will land on persoanl details
            dispatch(clearUserData());
            dispatch(clearSSLData());
            const localStorgemid1 = getGEMID1();
            const localStorgemid2 = getGEMID2();
            if (!localStorgemid1 && !localStorgemid2)
                localStorage.setItem("sourceCode", "WEBS");
            goto = "personalDetails";
        } else if (userDetail.hasOwnProperty('consentFlag') && userDetail?.consentFlag === "N") {
            // when lead is non-consented
            goto = "personalDetails";
            // dispatch(appNavigateTo({ goTo: "personalDetails", }, "APP_NAVIGATE_TO"));
        } else if((userDetail?.state === "RT006" || userDetail?.state === "RT007") && isFFNCard(userDetail?.cardType) && (userDetail?.ffnNo === undefined || userDetail?.ffnNo === "")) {
            goto = "Changeffno";
        }
        else {
            goto = "landingPage";
        }
        updateState("landingPageLoad", screenDetails.goTo);
        dispatch(appNavigateTo({ goTo: goto, }, "APP_NAVIGATE_TO"));
    } else if (revisit && eApplyCookie === null && userDetail?.state === undefined) {
        let goto = "help";
        updateState("landingPageLoad", screenDetails.goTo);
        dispatch(appNavigateTo({ goTo: goto, }, "APP_NAVIGATE_TO"));
    }
}